import { Injectable } from '@angular/core';
//import { TranslationPipe } from '../pipes/translation.pipe';
import { TranslationService } from 'src/app/service/api/translation.service';
import { TranslationRequest } from '../models/TranslationRequest';

@Injectable({
  providedIn: 'root'
})
export class VoeService {
    

    constructor(
      private translationService: TranslationService,
     // private translatePipe: TranslationPipe
    ) { }

    getAliasedLabel(labelOverrideFor: string, aliasLabel: { value: string; }): string {
       return aliasLabel == undefined || aliasLabel.value == "employee id"
       ? "Employee id"
       : aliasLabel.value;
  }
}
